/* eslint-disable yoda */

/**
 * Checks if a given URL string contains "youtube" or "vimeo" (case-insensitive).
 * This is used to disable the Add button until a valid link is provided.
 * @param {string} link - The URL string from the input field.
 * @param {string} type - The media type
 * @returns {boolean} True if the link contains a valid video provider, false otherwise.
 */
export const isValidLink = (link, type) => {
  if (!link || typeof link !== 'string') {
    return false;
  }
  const lowerLink = link.toLowerCase();

  if (type === 'video') {
    return lowerLink.includes('youtube') || lowerLink.includes('vimeo');
  }
  return lowerLink.includes('matterport');
};
